// NavigationArrows Component
// Floating navigation arrows that allow scrolling up/down through sections

import React, { useState, useEffect, useCallback } from 'react';
import './NavigationArrows.css';
import SidebarButton from './SidebarButton';
import { SECTIONS } from '../constants';

function NavigationArrows() {
  const [showUpArrow, setShowUpArrow] = useState(false);
  const [showDownArrow, setShowDownArrow] = useState(true);

  const sections = SECTIONS;

  // Get the current section index based on scroll position
  const getCurrentSectionIndex = useCallback(() => {
    const scrollPosition = window.scrollY + window.innerHeight / 2;
    
    for (let i = sections.length - 1; i >= 0; i--) {
      let element;
      
      element = document.getElementById(sections[i]);
      
      if (element && element.offsetTop <= scrollPosition) {
        return i;
      }
    }
    return 0;
  }, [sections]);

  // Update arrow visibility based on scroll position
  const updateArrowVisibility = useCallback(() => {
    const isAtTop = window.scrollY < 100;
    
    // Check if we're at the footer
    const footer = document.querySelector('.footer');
    const footerTop = footer ? footer.offsetTop : Infinity;
    const isAtFooter = window.scrollY + window.innerHeight >= footerTop + 100;
    
    // Show up arrow if not at the very top
    setShowUpArrow(!isAtTop);
    
    // Show down arrow if not at footer
    setShowDownArrow(!isAtFooter);
  }, []);

  // Scroll to top
  const scrollToTop = () => {
    const heroSection = document.getElementById('hero-root');
    if (heroSection) {
      heroSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      // Fallback if hero section not found
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  // Scroll to next section
  const scrollToNextSection = () => {
    const currentIndex = getCurrentSectionIndex();
    
    // If at contact section, scroll to footer
    if (currentIndex >= sections.length - 1) {
      const footer = document.querySelector('.footer');
      if (footer) {
        footer.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
      return;
    }
    
    // Scroll to next section
    const nextIndex = currentIndex + 1;
    let nextElement;
    
    nextElement = document.getElementById(sections[nextIndex]);
    
    if (nextElement) {
      nextElement.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // Set up scroll listener
  useEffect(() => {
    updateArrowVisibility();
    window.addEventListener('scroll', updateArrowVisibility);
    
    // Update on window resize as well
    window.addEventListener('resize', updateArrowVisibility);
    
    return () => {
      window.removeEventListener('scroll', updateArrowVisibility);
      window.removeEventListener('resize', updateArrowVisibility);
    };
  }, [updateArrowVisibility]);

  return (
    <div className="navigation-arrows-container">
      {/* Up Arrow - Scroll to top */}
      <SidebarButton
        iconClass="fas fa-chevron-up"
        className={`nav-arrow nav-arrow-up ${showUpArrow ? 'visible' : 'hidden'}`}
        onClick={scrollToTop}
        ariaLabel="Scroll to top"
      />

      {/* Down Arrow - Scroll to next section */}
      <SidebarButton
        iconClass="fas fa-chevron-down"
        className={`nav-arrow nav-arrow-down ${showDownArrow ? 'visible' : 'hidden'}`}
        onClick={scrollToNextSection}
        ariaLabel="Scroll to next section"
      />
    </div>
  );
}

export default NavigationArrows;

